import { Component, EventEmitter, Input, Output } from '@angular/core'
import { DateFormatService } from 'dmmp-services'

@Component({
  selector: 'dmmp-website-article-banner-featured',
  templateUrl: './website-article-banner-featured.component.html',
})
export class WebsiteArticleBannerFeaturedComponent {
  @Input() data
  @Input() type
  @Input() quantityTitle = 90
  @Input() classArticle
  @Output() page = new EventEmitter()
  constructor(public dateFormat: DateFormatService) {}
}
